module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "grid-6"
  }, [_c('input-number', {
    attrs: {
      "min": "0",
      "max": "120",
      "value": _vm.hours,
      "model": "hours",
      "label": "Hours"
    },
    on: {
      "update-value": _vm.updateValue
    },
    model: {
      value: (_vm.hours),
      callback: function($$v) {
        _vm.hours = _vm._n($$v)
      },
      expression: "hours"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-6"
  }, [_c('input-number', {
    attrs: {
      "min": "0",
      "max": "59",
      "value": _vm.minutes,
      "model": "minutes",
      "label": "Minutes"
    },
    on: {
      "update-value": _vm.updateValue,
      "hit-minute-max": _vm.hitMinuteMax,
      "hit-minute-min": _vm.hitMinuteMin
    },
    model: {
      value: (_vm.minutes),
      callback: function($$v) {
        _vm.minutes = _vm._n($$v)
      },
      expression: "minutes"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-548dd598"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputTime.vue
// module id = 35
// module chunks = 0